import React from "react";
import { Link, useNavigate } from "react-router-dom";
// reactstrap components
import {

  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container
} from "reactstrap";

import Funciones from "../../views/Molda/Funciones.js";
import Organigrama from "../../views/Molda/Organigrama.js";
import Tramites from "../../views/Molda/Tramites.js";
import Mision from "../../views/Molda/Mision.js";

const ID_SECCION_CONTACTO = "contacto";

const irASeccionContacto = (e, navigate) => {
  e.preventDefault();
  const seccion = document.getElementById(ID_SECCION_CONTACTO);
  if (seccion) {
    seccion.scrollIntoView({ behavior: "smooth", block: "start" });
    if (window.location.hash !== `#${ID_SECCION_CONTACTO}`) {
      window.history.replaceState(null, "", `/#${ID_SECCION_CONTACTO}`);
    }
    return;
  }
  navigate(`/#${ID_SECCION_CONTACTO}`);
};

const irAInicio = (e, navigate) => {
  e.preventDefault();
  if (window.location.pathname === "/") {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (window.location.hash) {
      window.history.replaceState(null, "", "/");
    }
    return;
  }
  navigate("/");
};

function DropdownWhiteNavbar() {
  const navigate = useNavigate();
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const[Modal1, setModal1] = React.useState(false);
  const[Modal2, setModal2] = React.useState(false);
  const[Modal3, setModal3] = React.useState(false);
  const[Modal4, setModal4] = React.useState(false);

  const cerrarMenuMovil = () => {
    if (collapseOpen) {
      document.documentElement.classList.remove("nav-open");
      setCollapseOpen(false);
    }
  };

  React.useEffect(()=>{
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    let modal

    if(urlParams.has('modal')){
        modal = urlParams.get('modal')
        switch(modal){
          case '3.4':setModal1(true); break;
          case '3.1':setModal2(true); break;
          case '9.1':setModal3(true); break;
          case '3.2':setModal4(true); break;     
          default: break;     
        }
    }    
  },[])
  return (
    <>
      <style>{`
        @media (min-width: 1200px) {
          #navbar-brand img { width: 160px !important; height: auto !important; max-width: none !important; max-height: none !important; }
        }
        @media (min-width: 992px) and (max-width: 1199px) {
          #navbar-brand img { width: 115px !important; height: auto !important; max-width: none !important; max-height: none !important; }
          #navbar-brand { margin-left: -8px !important; padding-left: 0 !important; }
        }
        @media (max-width: 991px) {
          #navbar-brand img { width: 105px !important; height: auto !important; }
          .navbar .navbar-translate { width: 100% !important; }
        }
      `}</style>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className="bg-white fixed-top" expand="lg" style={{ paddingTop: "18px", paddingBottom: "18px" }}>
        <Container style={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}>
          <div className="navbar-translate" style={{ width: "auto", display: "flex", alignItems: "center" }}>
            <NavbarBrand
              to="/"
              tag={Link}
              id="navbar-brand"
              onClick={(e) => {
                cerrarMenuMovil();
                irAInicio(e, navigate);
              }}
            >
              <img src={require("assets/img/Notaria/logoNot.png")} alt="Logo de la notaria 21 de Cali" style={{ width: "160px", height: "auto", maxHeight: "none", maxWidth: "none" }}></img>
            </NavbarBrand>
            <button
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              className="navbar-toggler"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse isOpen={collapseOpen} navbar style={{ flexGrow: 1 }}>
            <Nav className="ml-auto" id="ceva" navbar style={{ marginRight: "30px", alignItems: "center" }}>
              <NavItem>
                <NavLink
                  href="/"
                  style={{padding: "8px 10px"}}
                  onClick={(e) => {
                    cerrarMenuMovil();
                    irAInicio(e, navigate);
                  }}
                >
                  <span style={{fontSize: "11px", fontWeight: "bold"}}>INICIO</span>
                </NavLink>
              </NavItem>
              <UncontrolledDropdown nav>
                  <DropdownToggle
                    caret
                    color="default"
                    data-toggle="dropdown"
                    id="navbarDropdownMenuLink1"
                    nav
                    onClick={(e) => e.preventDefault()}
                    style={{padding: "8px 10px"}}
                  >
                    <span style={{fontSize: "11px", fontWeight: "bold"}}>SERVICIOS NOTARIALES</span>
                  </DropdownToggle>
                <DropdownMenu aria-labelledby="navbarDropdownMenuLink1" end>
                  {/* <DropdownItem href="http://notariavirtual.notaria21cali.com.co/" >
                    <i className="now-ui-icons tech_laptop"></i>
                    Notaría Virtual
                  </DropdownItem> */}
                  <DropdownItem to="/cotizador" tag={Link}>
                    <i className="now-ui-icons tech_laptop"></i>
                    Cotizador
                  </DropdownItem>
                  
                  <DropdownItem to="/clientescorporativos" tag={Link}>
                    <i className="now-ui-icons business_briefcase-24"></i>
                    Clientes corporativos
                  </DropdownItem>
                  <DropdownItem to="/registroCivil" tag={Link}>
                    <i className="now-ui-icons business_briefcase-24"></i>
                    Registro Civil
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav>
                  <DropdownToggle
                    caret
                    color="default"
                    data-toggle="dropdown"
                    id="navbarDropdownMenuLink"
                    nav
                    onClick={(e) => e.preventDefault()}
                    style={{padding: "8px 10px"}}
                  >
                    <span style={{fontSize: "11px", fontWeight: "bold"}}>CONÓCENOS</span>
                  </DropdownToggle>
                <DropdownMenu aria-labelledby="navbarDropdownMenuLink" end>
                  <DropdownItem onClick={() => setModal2(true)}>
                    <i className="now-ui-icons files_single-copy-04"></i>
                    Misión y Visión 
                  </DropdownItem>
                  <DropdownItem  onClick={() => setModal4(true)}>
                    <i className="now-ui-icons users_circle-08"></i>
                    Funciones y deberes
                  </DropdownItem>
                  <DropdownItem to="/procesos" tag={Link}>
                    <i className="now-ui-icons ui-2_settings-90"></i>
                    Procesos y procedemiento
                  </DropdownItem>
                  <DropdownItem to="/Organigrama" tag={Link}>
                    <i className="now-ui-icons design_image"></i>
                    Organigrama
                  </DropdownItem>
                  <DropdownItem to="/#linea" tag={Link} >
                    <i className="now-ui-icons education_paper"></i>
                    Noticias
                  </DropdownItem>
                  <DropdownItem to="/notario" tag={Link}>
                    <i className="now-ui-icons business_badge"></i>
                    Notario
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav>
                  <DropdownToggle
                    caret
                    color="default"
                    data-toggle="dropdown"
                    id="navbarDropdownMenuLink1"
                    nav
                    onClick={(e) => e.preventDefault()}
                    style={{padding: "8px 10px"}}
                  >
                    <span style={{fontSize: "11px", fontWeight: "bold"}}>ATENCION Y SERVICIOS A LA CIUDADANIA</span>
                  </DropdownToggle>
                <DropdownMenu aria-labelledby="navbarDropdownMenuLink1" end>
                  <DropdownItem onClick={() => setModal3(true)}>
                    <i className="now-ui-icons files_paper"></i>
                    Información
                  </DropdownItem>
                  <DropdownItem to="/servicios" tag={Link}>
                    <i className="now-ui-icons education_agenda-bookmark"></i>
                    Servicios
                  </DropdownItem>
                  <DropdownItem to="/tarifa" tag={Link}>
                    <i className="now-ui-icons business_money-coins"></i>
                    Tarifas
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <NavItem>
                <NavLink
                  href={`/#${ID_SECCION_CONTACTO}`}
                  style={{padding: "8px 10px"}}
                  onClick={(e) => {
                    cerrarMenuMovil();
                    irASeccionContacto(e, navigate);
                  }}
                >
                  <span style={{fontSize: "11px", fontWeight: "bold"}}>CONTÁCTENOS</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/transparencia/0" tag={Link} style={{padding: "8px 10px"}}>
                  <span style={{fontSize: "11px", fontWeight: "bold"}}>TRANSPARENCIA</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/participa" tag={Link} style={{padding: "8px 10px"}}>
                  <span style={{fontSize: "11px", fontWeight: "bold"}}>PARTICIPA</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/zonaPagos" tag={Link} style={{padding: "8px 10px"}}>
                  <span style={{fontSize: "11px", fontWeight: "bold"}}>ZONA PAGOS</span>
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
      <Organigrama modal={Modal1} setModal={() => setModal1(false)}/>
      <Mision modal={Modal2} setModal={() => setModal2(false)}/>
      <Tramites modal={Modal3} setModal={() => setModal3(false)}/>
      <Funciones modal={Modal4} setModal={() => setModal4(false)}/>
      {/* <Modal isOpen={Modal1} toggle={() => setModal1(false)} className="modal-lg modal-dialog modal-dialog-centered">
        <div style={{backgroundColor: "White" ,borderRadius: "15px", border: "3px solid #979797"}}>
            <div className="modal-header">
                <h3> </h3>
                <button
                aria-label="Close"
                className="close"
                type="button"
                onClick={() => setModal1(false)}
                >
                <span aria-hidden={true}><i className="now-ui-icons ui-1_simple-remove"></i></span>
                </button>
            </div>
            <ModalBody>
                <h1 className="text-center title">
                    <b style={{color : "#1c6e38"}}>Organigrama</b><br></br>
                </h1>
                <Row>
                  <Col md="12">
                  <img
                      alt="..."
                      width="100%"
                      src={require("assets/img/Notaria/organigrama.JPG")}
                  ></img>
                  </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="default"
                    type="button"
                    onClick={() => setModal1(false)}
                    className="text-center"
                >
                    <b style={{fontSize: "17px"}}>Cerrar</b>
                </Button>
            </ModalFooter>
        </div>
    </Modal> */}
    {/* <Modal isOpen={Modal2} toggle={() => setModal2(false)} className="modal-lg modal-dialog modal-dialog-centered">
        <div style={{backgroundColor: "White" ,borderRadius: "15px", border: "3px solid #979797"}}>
            <div className="modal-header">
                <h3> </h3>
                <button
                aria-label="Close"
                className="close"
                type="button"
                onClick={() => setModal2(false)}
                >
                <span aria-hidden={true}><i className="now-ui-icons ui-1_simple-remove"></i></span>
                </button>
            </div>
            <ModalBody>
                <h3 className="text-center title">
                    <b style={{color : "#1c6e38"}}>Misión</b><br></br>
                </h3>
                <h5 className="description text-justify" style={{color: "Black"}}>
                    <b>Ofrecemos los servicios notariales con sentido social, de manera efectiva, personalizada, 
                      contando con tecnología adecuada y personal altamente capacitado; buscando permanentemente 
                      la excelencia.  Destacándonos por brindar asesoría rápida, confiable, dando solución real a 
                      la demanda de los usuarios, dentro del marco legal. </b>
                </h5>
                <h3 className="text-center title">
                    <b style={{color : "#1c6e38"}}>Visión</b><br></br>
                </h3>
                <h5 className="description text-justify" style={{color: "Black"}}>
                    <b>Ser en los próximos cinco años una notaria líder en el suroccidente colombiano,  
                      en la prestación del servicio, cumpliendo los requisitos legales, utilizando 
                      tecnología avanzada y ejecutando continuamente políticas de capacitación 
                      al personal para atraer más usuarios a partir de la confianza, lealtad y 
                      total satisfacción de los mismos.</b>
                </h5>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="default"
                    type="button"
                    onClick={() => setModal2(false)}
                    className="text-center"
                >
                    <b style={{fontSize: "17px"}}>Cerrar</b>
                </Button>
            </ModalFooter>
        </div>
    </Modal> */}
    </>
  );
}

export default DropdownWhiteNavbar;
